module.exports = __webpack_public_path__ + "static/media/avatar-6.11d7dc68.jpg";